// extracted by mini-css-extract-plugin
export default {"dataGridContainer":"styles_dataGridContainer__i9kSV","loaderCont":"styles_loaderCont__9m0ol","btnContainer":"styles_btnContainer__H+3fU"};